export default __webpack_public_path__ + "static/media/page1.541aa0ae.png";